"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require("react-redux");

var _styles = require("@material-ui/styles");

var _Typography = require("@material-ui/core/Typography");

var _Typography2 = _interopRequireDefault(_Typography);

var _DescriptionOutlined = require("@material-ui/icons/DescriptionOutlined");

var _DescriptionOutlined2 = _interopRequireDefault(_DescriptionOutlined);

var _appCore = require("@manakin/app-core");

var _actions = require("@manakin/core/dist/actions");

var _jsFileDownloader = require("js-file-downloader");

var _jsFileDownloader2 = _interopRequireDefault(_jsFileDownloader);

var _graphql = require("../graphql");

var _reactHooks = require("@apollo/react-hooks");

var _UploadedFile = require("./UploadedFile");

var _UploadedFile2 = _interopRequireDefault(_UploadedFile);

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
	return {
		subHeader: {},
		uploadBox: {
			width: " 100%",
			height: "100%",
			border: "2px dashed #EFEFEF",
			display: "flex",
			flexDirection: "column",
			padding: theme.spacing(2) + "px " + theme.spacing(3) + "px"
		},
		uploadBoxEmpty: {
			alignItems: "center",
			justifyContent: "center"
		},
		uploadIcon: {
			width: 72,
			height: 72,
			color: "#C4C4C4",
			marginBottom: theme.spacing(2)
		},
		uploadInfo: {
			width: "50%",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			textAlign: "center"
		},
		link: {
			color: theme.manakin.indicationColor[500]
		},
		uploadedContainer: {
			width: "100%",
			height: "100%",
			display: "flex",
			flexDirection: "column"
		},
		uploadedFilesContainer: {
			flexGrow: 1
		},
		uploadedFiles: {
			overflow: "auto",
			maxHeight: 350
		},
		uploadedLink: {
			marginTop: theme.spacing(2),
			marginRight: theme.spacing(2),
			cursor: "pointer",
			textDecoration: "underline",
			textTransform: "capitalize"
		}
	};
});

var UploadBox = function UploadBox(props) {
	var className = props.className,
	    _props$data = props.data,
	    data = _props$data === undefined ? {} : _props$data,
	    readOnly = props.readOnly,
	    hideDelete = props.hideDelete;

	var classes = useStyles();
	var dispatch = (0, _reactRedux.useDispatch)();

	var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    openFileUpload = _useState2[0],
	    setOpenFileUpload = _useState2[1];

	var _useTranslation = (0, _reactI18next.useTranslation)(),
	    t = _useTranslation.t;

	var MAX_FILE_SIZE_LIMIT = 100; // MB limit for file upload

	var _useQuery = (0, _reactHooks.useQuery)(_graphql.GQL_FETCH_RATING_STUDENT_RESULT_ASSETS, {
		variables: {
			programId: data.programId,
			boxId: data.boxId,
			elementId: data.elementId,
			studentId: data.studentId
		}
	}),
	    _useQuery$data = _useQuery.data,
	    ratingStudentResultAssetsData = _useQuery$data === undefined ? {} : _useQuery$data,
	    refetch = _useQuery.refetch;

	var _useMutation = (0, _reactHooks.useMutation)(_graphql.GQL_UPLOAD_ASSET),
	    _useMutation2 = _slicedToArray(_useMutation, 1),
	    uploadAsset = _useMutation2[0];

	var _useMutation3 = (0, _reactHooks.useMutation)(_graphql.GQL_UPDATE_RATING_STUDENT_RESULT),
	    _useMutation4 = _slicedToArray(_useMutation3, 1),
	    updateRatingStudentResult = _useMutation4[0];

	var _ratingStudentResultA = ratingStudentResultAssetsData.ratingStudentResult,
	    ratingStudentResult = _ratingStudentResultA === undefined ? {} : _ratingStudentResultA;

	var _ref = ratingStudentResult || {},
	    _ref$assets = _ref.assets,
	    assets = _ref$assets === undefined ? [] : _ref$assets;

	var handleDeleteFile = function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(asset) {
			var index, newAssets, success;
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							index = assets.findIndex(function (findAsset) {
								return findAsset.id === asset.id;
							});

							if (!(index < 0)) {
								_context.next = 3;
								break;
							}

							return _context.abrupt("return");

						case 3:
							newAssets = [].concat(_toConsumableArray(assets));

							newAssets.splice(index, 1);

							_context.next = 7;
							return updateRatingStudentResult({
								variables: {
									input: {
										id: ratingStudentResult.id,
										assets: newAssets.map(function (asset) {
											return { id: asset.id };
										})
									}
								}
							}).then(function (result) {
								return result && result.data && result.data.updateRatingStudentResult;
							}).catch(function (e) {
								return false;
							});

						case 7:
							success = _context.sent;


							if (success) {
								refetch();
								snackBar(t("app.document-upload.upload-box.delete-success"), "success");
							} else {
								snackBar(t("app.document-upload.upload-box.delete-failed"), "error");
							}

						case 9:
						case "end":
							return _context.stop();
					}
				}
			}, _callee, undefined);
		}));

		return function handleDeleteFile(_x) {
			return _ref2.apply(this, arguments);
		};
	}();

	var handleUploadFile = function () {
		var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
			var programId, boxId, elementId, studentId, uploadRatingFile;
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							programId = data.programId, boxId = data.boxId, elementId = data.elementId, studentId = data.studentId;

							if (!readOnly) {
								_context2.next = 3;
								break;
							}

							return _context2.abrupt("return");

						case 3:
							_context2.next = 5;
							return uploadAsset({
								variables: {
									programId: programId,
									boxId: boxId,
									elementId: elementId,
									file: file
								},
								context: { hasUpload: true }
							}).then(function (result) {
								return result.data && result.data.uploadRatingFile;
							}).catch(function (e) {
								return false;
							});

						case 5:
							uploadRatingFile = _context2.sent;


							if (uploadRatingFile) {
								refetch();
								snackBar(t("app.document-upload.upload-box.upload-success"), "success");
							} else {
								snackBar(t("app.document-upload.upload-box.upload-failed"), "error");
							}

						case 7:
						case "end":
							return _context2.stop();
					}
				}
			}, _callee2, undefined);
		}));

		return function handleUploadFile(_x2) {
			return _ref3.apply(this, arguments);
		};
	}();

	var handleFilesUpload = function () {
		var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(newFiles) {
			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							if (!readOnly) {
								_context3.next = 2;
								break;
							}

							return _context3.abrupt("return");

						case 2:
							if (!(assets.length === 2)) {
								_context3.next = 4;
								break;
							}

							return _context3.abrupt("return");

						case 4:
							if (!(newFiles.length === 0)) {
								_context3.next = 6;
								break;
							}

							return _context3.abrupt("return");

						case 6:
							if (!(newFiles.length > 1)) {
								_context3.next = 14;
								break;
							}

							_context3.next = 9;
							return handleUploadFile(newFiles[0]);

						case 9:
							if (!(assets.length === 0)) {
								_context3.next = 12;
								break;
							}

							_context3.next = 12;
							return handleUploadFile(newFiles[1]);

						case 12:
							_context3.next = 16;
							break;

						case 14:
							_context3.next = 16;
							return handleUploadFile(newFiles[0]);

						case 16:

							handleCloseFileUpload();

						case 17:
						case "end":
							return _context3.stop();
					}
				}
			}, _callee3, undefined);
		}));

		return function handleFilesUpload(_x3) {
			return _ref4.apply(this, arguments);
		};
	}();

	var handleOpenFileUpload = function handleOpenFileUpload() {
		if (readOnly) return;
		setOpenFileUpload(true);
	};

	var handleCloseFileUpload = function handleCloseFileUpload() {
		setOpenFileUpload(false);
	};

	var handleFileClick = function handleFileClick(asset) {
		new _jsFileDownloader2.default({
			url: asset.url,
			filename: asset.name
		}).then(function () {
			snackBar(t("app.document-upload.upload-box.download-success"), "success");
		}).catch(function (_) {
			snackBar(t("app.document-upload.upload-box.download-failed"), "error");
		});
	};

	var snackBar = function snackBar(message, variant) {
		return dispatch((0, _actions.showSnackbarMessage)({
			text: message,
			variant: variant
		}));
	};

	return _react2.default.createElement(
		_appCore.FileUploadDragDrop,
		{
			name: "file",
			label: "Upload documenten",
			accept: "application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,image/jpeg,image/png",
			fileSizeLimit: MAX_FILE_SIZE_LIMIT,
			enabled: openFileUpload,
			maxFiles: 2,
			onFilesUpload: handleFilesUpload
		},
		_react2.default.createElement(
			"div",
			{
				className: (0, _classnames2.default)(classes.uploadBox, className, _defineProperty({}, classes.uploadBoxEmpty, assets.length === 0))
			},
			assets.length === 0 && _react2.default.createElement(
				"div",
				{ className: classes.uploadInfo },
				_react2.default.createElement(_DescriptionOutlined2.default, { className: classes.uploadIcon }),
				readOnly ? _react2.default.createElement(
					_Typography2.default,
					{ component: "div", variant: "body1" },
					t("app.document-upload.upload-box.no-files-read-only")
				) : _react2.default.createElement(
					_Typography2.default,
					{ component: "div", variant: "body1" },
					t("app.document-upload.upload-box.no-files"),
					" ",
					_react2.default.createElement(
						"a",
						{
							className: classes.link,
							onClick: handleOpenFileUpload
						},
						t("common.select").toLowerCase()
					)
				)
			),
			assets && assets.length > 0 && _react2.default.createElement(
				"div",
				{ className: classes.uploadedContainer },
				_react2.default.createElement(
					"div",
					{ className: classes.uploadedFilesContainer },
					_react2.default.createElement(
						"div",
						{ className: classes.uploadedFiles },
						assets && assets.map(function (asset) {
							return _react2.default.createElement(_UploadedFile2.default, {
								key: asset.id,
								onFileDelete: handleDeleteFile,
								onFileClick: handleFileClick,
								asset: asset,
								readOnly: hideDelete
							});
						})
					)
				),
				!readOnly && assets.length < 2 && _react2.default.createElement(
					"a",
					{
						className: (0, _classnames2.default)(classes.link, classes.uploadedLink),
						onClick: handleOpenFileUpload
					},
					t("common.select")
				)
			)
		)
	);
};

exports.default = UploadBox;